import { useIntl } from 'react-intl';

import { ampli } from '../../../../core/Tracking/Amplitude/__AUTO_GENERATED__';
import { TrackingProperties } from '../../../../core/Tracking/Amplitude/Amplitude';
import { Destination } from '../../../../resources/destination/domain/types/destination';
import { PickDomain } from '../../../../shared/utilities/types/PickDomain';
import { LogoOptionWay } from '../../illustration/LogoOptionWay';

import { TransportCard } from './TransportCard';

type OptionWayTransportCardProps = {
    destination: PickDomain<Destination, 'id' | 'slug'>;
    trackingInformation: {
        transportSearchClicked: Pick<
            TrackingProperties<typeof ampli.transportSearchClicked>,
            'block'
        >;
    };
    optionWayUrl: string;
    className?: string;
    isCompact?: boolean;
};

export function OptionWayTransportCard({
    destination,
    trackingInformation,
    className,
    optionWayUrl,
    isCompact = false,
}: OptionWayTransportCardProps) {
    const { formatMessage } = useIntl();

    return (
        <TransportCard
            isCompact={isCompact}
            title={formatMessage({
                id: isCompact
                    ? 'global.component.transports.flight.shortTitle'
                    : 'global.component.transports.flight.title',
            })}
            subtitle={formatMessage({
                id: 'global.component.transports.flight.subtitle',
            })}
            description={formatMessage({
                id: 'global.component.transports.flight.description',
            })}
            linkUrl={optionWayUrl}
            linkLabel={formatMessage({
                id: 'global.component.transports.flight.link',
            })}
            Logo={LogoOptionWay}
            trackingInformation={{
                transportSearchClicked: {
                    ...trackingInformation.transportSearchClicked,
                    destination_id: destination.id,
                    destination_slug: destination.slug,
                    transport_type: 'plane',
                },
            }}
            className={className}
        />
    );
}
